import { Component, effect, inject } from '@angular/core';
import { DisplayPackOptionsComponent } from 'src/app/shared/components/display-pack-options/display-pack-options.component';
import { ApiAccessComponent } from './api-access/api-access.component';
import { Pack } from 'src/app/shared/model/pack';
import { CurrentUserService } from 'src/app/shared/services/current-user.service';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrl: './billing.component.scss',
  imports: [DisplayPackOptionsComponent, ApiAccessComponent],
})
export class BillingComponent {
  currentUserService = inject(CurrentUserService);
  pack?: Pack;
  companyId?: string;
  usedTrips?: number;
  usedUsers?: number;

  constructor() {
    effect(() => {
      this.pack = this.currentUserService.currentUser()?.company?.pack;
      this.companyId = this.currentUserService.currentUser()?.companyId;
      this.usedTrips =
        this.currentUserService.currentUser()?.company?._count?.trips;
      this.usedUsers =
        this.currentUserService.currentUser()?.company?._count?.users;
    });
  }
}
